// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('login', {
        url: '/login',
        controller: 'LoginController',
        data: { pageTitle: 'Login' }

    });
}

// @ngInject
function LoginController($location,AuthService) {
    if (!AuthService.hasToken()) {
        AuthService.showLogin();
    } else {
        $location.path("/");
    }
}

angular
    .module('login', ['auth.api'])
    .config(stateConfig)
    .controller('LoginController', LoginController);
